module.exports = __webpack_public_path__ + "media/admin/components/worker-plugins/model-checkbox/school-image-a19315d28dcd2d24d3aa8b0cb814fdaa.png";